module.exports = __webpack_public_path__ + "0123fccfd1e3eb9c6ebcb9c1ce66f5ac.jpg";